module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/249.05f31feb.png";